module.exports = __webpack_public_path__ + "media/images/womans-well-being-5c7ff95a0f8f4c67ce9df6f6b75c1e80.jpg";